import {
  getUrlParam,
  isAlipayMiniUa,
  isBaiduBoxUa,
  isQuickAppUa,
  setStorage,
  getStorage,
  isJdMiniProgram,
  removeStorage,
  isCompanyApp,
  callApp,
  isHllApp,
  isWxMiniProgram,
  genAccessTokenStr,
  isXlMiniProgram,
  isXlAppByClientType
} from '@/utils';
import { mapState, mapMutations } from 'vuex';
import getCompanyToken from '@/utils/getCompanyToken';
import HllUI from '@/libs/hll-m-ui';
// import sensors from'sa-sdk-javascript';
import Vue from 'vue';

function timeoutHanle(time = 1000) {
  return new Promise(res => res(true), time);
}
//登录埋点
function trackByFid(context, fid) {
  try {
    context.$sensors.login(fid);
  } catch (err) {
    console.log(err);
  }
}
function tokenLogRedirect(query) {
  return new Promise(async resolve => {
    if (isXlMiniProgram()) {
      // 小拉 微信小程序
      return wx.miniProgram.reLaunch({
        url: `/pages/index/index?webview=${encodeURIComponent(location.href)}`
      });
    }

    if (isXlAppByClientType()) {
      // 小拉 app
      return my.reLaunch({
        url: `/pages/index/index?webview=${encodeURIComponent(location.href)}`
      });
    }

    //没有token
    if (isWxMiniProgram() && getUrlParam('ua')) {
      //判断是否是货拉拉微信小程序(如果没有该附加条件零担小程序也会进入这一步导致出错)
      //小程序
      return wx.miniProgram.navigateTo({
        url: '/pages/login/index' + (query || '')
      });
    }
    if (isJdMiniProgram()) {
      // 京东小程序
      return jd.miniProgram.navigateTo({
        url: '/pages/login/index'
      });
    }
    if (isQuickAppUa()) {
      // 快应用
      return system.postMessage(
        JSON.stringify({
          action: 'login'
        })
      );
    }
    if (isAlipayMiniUa()) {
      //支付宝小程序
      return my.navigateTo({
        url: '/pages/login/index'
      });
    }
    if (isBaiduBoxUa()) {
      return swan.webView.navigateTo({
        url: '/pages/login/index'
      });
    }
    // 小拉原生app 也会走到这个情况
    if (isHllApp()) {
      //App内
      console.log(navigator.userAgent, 'isHllApp ua +++++');
      var args = JSON.stringify({
        action: isCompanyApp() ? 'jumpToLogin' : 'login'
      });
      console.log(args, 'args+++++');
      var iOS = !!navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
      if (isCompanyApp()) {
        if (iOS) {
          HllUI.$hll.toast('请登录后进入');
          await timeoutHanle(2000);
        }
        return callApp(
          JSON.stringify({
            action: 'openNativePage',
            type: 1
          })
        );
      }
      return iOS
        ? window.webkit.messageHandlers.app.postMessage(args)
        : app.webcall(args);
    }
    return resolve(true);
  });
}
export const getAccessTokenByToken = async (token, env, config = {}) => {
  if (!token) {
    //没有token
    return false;
  }
  return Vue.prototype.$axios
    .post('/act/passport/token_in', {
      token: token,
      user_type: env
    })
    .then(e => {
      let accessToken = e.access_token || e.accessToken;
      trackByFid(Vue.prototype, e.hash_fid);
      setStorage(`${env}_hash_fid`, e.hash_fid);
      setStorage(`${env}_token`, token); //缓存新的token
      setStorage(genAccessTokenStr(config.accountType), accessToken); // 缓存对应账户体系的 accessToken
      return accessToken;
    })
    .catch(error => {
      //token 过期
      if (/^8006|988$/.test(error.ret)) {
        removeStorage(genAccessTokenStr(config.accountType)); // 清除对应账户体系的 access_token
      }
      return false;
    });
};

let TokenIn = {
  computed: {
    ...mapState('global', ['env', 'appToken', 'accountType'])
  },
  methods: {
    ...mapMutations('global', ['set_appToken']),
    checkCompanyLog() {
      return new Promise(async res => {
        try {
          if (isCompanyApp()) {
            let token = await getCompanyToken();
            this.set_appToken(token);
            await timeoutHanle(200);
            return res(token);
          }
        } catch (err) {
          console.error(err);
        }
        return res(true);
      });
    },
    /**
     * feature: 2021/05/19 support more account systerms.
     *        - 前端是通过 url path里的 query参数。actype=xiaola, default 是之前的。
     * 参数query用于给小程序端传递登录页面参数
     * @param {String} query 形如 ?a=1&b=2
     * @param {Boolean} isIgnoreToken 是否忽略token判断，每次都请求刷新token、access_token
     * @param {Object} externalParams 针对某个活动需要传的额外的特定参数 // 例如小拉 邀请好友 进入受邀者页面更换token时，传入invitonCode 进行识别新用户
     */
    needLogin(query, isIgnoreToken, externalParams = {}) {
      return new Promise(async (resolve, reject) => {
        await this.checkCompanyLog();
        let token =
          getUrlParam('token') || getUrlParam('_token') || this.appToken; //当前token
        let localToken = getStorage(`${this.env}_token`); //缓存的token
        // 针对多个账户体系
        let localAccessToken = getStorage(genAccessTokenStr(this.accountType)); //缓存的access_token
        let hashFid = getStorage(`${this.env}_hash_fid`); //神策上报的fid
        let routes = this.$router.options.routes;
        if (localAccessToken && token == localToken && !isIgnoreToken) {
          //身份一致,并且存在accessToken
          if (hashFid) {
            trackByFid(this, hashFid);
          }
          return resolve(localAccessToken); //直接resolve
        }
        if (token) {
          //有token
          this.$axios
            .post('/act/passport/token_in', {
              token: token,
              user_type: this.env,
              ...externalParams
            })
            .then(e => {
              let accessToken = e.access_token || e.accessToken;
              trackByFid(this, e.hash_fid);
              setStorage(`${this.env}_hash_fid`, e.hash_fid);
              setStorage(`${this.env}_token`, token); //缓存新的token
              setStorage(genAccessTokenStr(this.accountType), accessToken); //缓存accessToken
              resolve(accessToken);
            })
            .catch(async error => {
              //token 过期
              if (/^8006|988$/.test(error.ret)) {
                removeStorage(genAccessTokenStr(this.accountType)); // 清除 access_token
                await tokenLogRedirect('', this.env);
                if (routes.some(e => e.path == '/login')) {
                  //路由中如果存在登录页,项目采取的 hashrouter 模式
                  return this.$router.replace('/login');
                }
              }
              reject(error);
            });
        } else {
          await tokenLogRedirect(query, this.env);
          //没有token
          // if (isWxMiniProgram() && getUrlParam('ua')) {
          //   //判断是否是货拉拉微信小程序(如果没有该附加条件零担小程序也会进入这一步导致出错)
          //   //小程序
          //   return wx.miniProgram.navigateTo({
          //     url: '/pages/login/index' + (query || '')
          //   });
          // }
          // if (isJdMiniProgram()) {
          //   // 京东小程序
          //   return jd.miniProgram.navigateTo({
          //     url: '/pages/login/index' + (query || '')
          //   });
          // }
          // if (isQuickAppUa()) {
          //   // 快应用
          //   return system.postMessage(
          //     JSON.stringify({
          //       action: 'login'
          //     })
          //   );
          // }
          // if (isAlipayMiniUa()) {
          //   //支付宝小程序
          //   return my.navigateTo({
          //     url: '/pages/login/index'
          //   });
          // }
          // if (isBaiduBoxUa()) {
          //   return swan.webView.navigateTo({
          //     url: '/pages/login/index'
          //   });
          // }
          // if (isHllApp()) {
          //   //App内
          //   var args = JSON.stringify({
          //     action: 'login'
          //   });
          //   var iOS = !!navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
          //   return iOS
          //     ? window.webkit.messageHandlers.app.postMessage(args)
          //     : app.webcall(args);
          // }

          //其他浏览器
          if (localAccessToken) {
            //例如微信,存在accessToken即认为已登录
            if (hashFid) {
              trackByFid(this, hashFid);
            }
            return resolve(localAccessToken);
          }
          //若不存在accessToken,则调登陆页面,没有登录页面的活动被认定为:只在app内投放
          if (routes.some(e => e.path == '/login')) {
            //路由中如果存在登录页
            return this.$router.replace('/login');
          } else {
            this.$hll.toast('请在货拉拉App内打开');
          }
          return reject(false);
        }
      });
    }
  }
};

export default TokenIn;
